module.exports = __webpack_public_path__ + "img/122.e00aee3e.png";